import { useEffect, useState } from "react";

import { Icon } from "../../../../assets/icons/Icon";
import { formatNumber, pluralize } from "../../../../helpers/helpers";
import { useElementWidth } from "../../../../hooks/useElementWidth";
import MiddleTruncateTextPx from "../../../dashboard/PageTable/MiddleTruncateUrl";
import Button from "../../../mantine/button/Button";
import Spinner from "../../../ui/spinner/Spinner";
import { ApprovePayload } from "../../onPage/types";
import styles from "./ExternalLinkTarget.module.scss";

const extractHref = (selectorString: string): string | null => {
  const match = selectorString.match(/href=['"]([^'"]*)['"]/);

  return match ? match[1] : null;
};

interface ExternalLinkItem {
  id?: number | string;
  path?: string;
  appearances?: number;
  active?: boolean;
  suggestion?: string;
  original?: string;
  url?: string;
  page_id?: number;
  approved?: boolean;
}

interface ExternalLinkTargetProps {
  data: ExternalLinkItem[];
  category?: {
    approved?: number;
    total?: number;
    category_name?: string;
  };
  approve: (data: ApprovePayload) => void;
  isLoading?: boolean;
}

const ExternalLinkTarget: React.FC<ExternalLinkTargetProps> = ({
  data,
  approve,
  isLoading = false,
}) => {
  const [wrapperRef, wrapperWidth] = useElementWidth<HTMLDivElement>(300);
  const [lastClickedId, setLastClickedId] = useState<number | string | null>(
    null,
  );

  useEffect(() => {
    if (!isLoading) {
      setLastClickedId(null);
    }
  }, [isLoading]);

  const handleApprove = (item: ExternalLinkItem, event: React.MouseEvent) => {
    event.stopPropagation();
    setLastClickedId(item.id || null);

    approve({
      kind: item.active ? "unapprove" : "approve",
      ids: typeof item.id === "number" ? [item.id] : undefined,
      variant: "automation",
    });
  };

  return (
    // @ts-expect-error TS2339 non-existing className
    <div className={styles.pageContainer} ref={wrapperRef}>
      <div className={styles.pageContent}>
        {data?.map((item, index) => {
          const url = item.path ? extractHref(item.path) : null;

          return (
            <div key={item.id || index} className={styles.externalLinkTarget}>
              <div className={styles.externalLinkTargetUrl}>
                {/*do not use RTL for urls*/}
                <MiddleTruncateTextPx
                  text={url || ""}
                  maxWidth={wrapperWidth === 0 ? 100 : wrapperWidth - 170}
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                />
                {item?.appearances && (
                  <span className={styles.externalLinkTargetUrlText}>
                    {formatNumber(item?.appearances)} (
                    {pluralize("appearance", item?.appearances)})
                  </span>
                )}
              </div>

              <div>
                {isLoading && lastClickedId === item.id ? (
                  <Spinner size="1rem" />
                ) : (
                  <Button
                    variant="nohoverWithPadding"
                    onClick={(event) => handleApprove(item, event)}
                  >
                    <Icon
                      iconName={
                        item.active ? "GreenCheckmarkIcon" : "CloseIconCircled"
                      }
                      width="1rem"
                      height="1rem"
                    />
                  </Button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ExternalLinkTarget;
